// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.awEHR5xs{align-items:center;display:flex;margin-top:.25em}.awEHR5xs input{margin:0 .25em 0 0}.QB6t2jJj{margin-left:.5em}`, "",{"version":3,"sources":["webpack://./src/form_components/CheckboxGroup.module.scss"],"names":[],"mappings":"AAAA,UACE,kBAAA,CACA,YAAA,CACA,gBAAA,CAEA,gBACE,kBAAA,CAIJ,UACE,gBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxOption": `awEHR5xs`,
	"checkboxOptions": `QB6t2jJj`
};
export default ___CSS_LOADER_EXPORT___;
